import { ReactComponent as BlankLink } from 'assets/icons/Group 240018.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/Layer_2.svg';
import { ReactComponent as ClassNoData } from 'assets/icons/class_noResult.svg';
import { formatDate } from 'helper/dateFormat';
import { numberFormat } from 'helper/numberFormat';
import React from 'react';
import './ClassInformation.scss';
import { fontConfig } from "theme/fontConfig";

const InternalDrawer = ({ formik }) => {
  const total = formik.values?.prices?.reduce((acc, curr) => {
    if(curr?.type?.toLowerCase() !== "on registration") return acc;
    return acc + (+curr?.amount || 0);
  }, 0);
  return (
    <>
      {formik.currentStepIndex !== 0 ? (
        <div className="internal_drawer">
          <h2 className="drawer_title">
            <div>Your Class</div>
            {/* <a
              className="d-flex align-items-center preview__class"
              href="https://shalom.eztmpl.dev/school"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BlankLink className="mr-2" /> Preview class
            </a> */}
          </h2>
          <div className="drawer_classInfo">
            <div className="class_info_title">
              <h3>Class Name</h3>
              <h3>Registration Starts-ends</h3>
            </div>
            <div className="class_info_value">
              {(formik.values?.class_name || formik.values?.year) && (
                <p>
                  {formik.values?.class_name} | {formik.values?.year}
                </p>
              )}
              {formik.values?.registration_starts && (
                <p>
                  {formik.values?.registration_starts ? formatDate({date:formik.values?.registration_starts,formatType:"defaultWithUTC"}) : ''} -{" "}
                  {formik.values?.alwaysAvailable ? "Always Available" : formik.values?.registration_ends ? formatDate({date:formik.values?.registration_ends,formatType:"defaultWithUTC"}) : ''}
                </p>
              )}
            </div>
          </div>
          <div className="class_details_section mt-4">
            <div>
              <h2
                title={numberFormat({number:+formik.values?.class_capacity, decimal:0, style:"decimal"})}
                style={{
                  width: '100px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'center',
                }}
              >
                {formik?.values?.infiniteParticipants ? <span style={{
                fontSize: '30px',
                fontFamily: fontConfig.SchoolInternalDrawerTextFont.family
              }}>&#8734;</span> : numberFormat({number:+formik.values?.class_capacity, decimal:0, style:"decimal"})}
              </h2>
              <h4>Max participants</h4>
            </div>
            <div>
              <h2>{formik.values?.age_range}</h2>
              <h4>Age Range</h4>
            </div>
          </div>
          {formik.values?.description !== '<p></p>\n' && (
            <div className="drawer_description">
              <h3>Description</h3>
              <p
                dangerouslySetInnerHTML={{ __html: formik.values?.description }}
              ></p>
            </div>
          )}
          <div className="non_member_allowing mt-4">
            <InfoIcon className="mr-3" />
            <p>
              Non-Members are{' '}
              {!formik.values?.allow_non_members_register && 'not'} allowed to
              register to this class
            </p>
          </div>
          <div className="price_section mt-10">
            {formik.values?.prices?.length > 0 &&
              formik.values?.prices?.map((price) => (
                <div className="subtotal mb-4">
                  <p>{price?.title}</p>
                  {price?.type === 'Optional' && price?.variant && price?.variantInfo?.length > 0 ? (() => {
                    const amounts = price.variantInfo.map((v) => +v.amount).filter((a) => !isNaN(a) && a > 0);
                    if (amounts.length === 0) return <h4>-</h4>;
                    const min = Math.min(...amounts);
                    const max = Math.max(...amounts);
                    return <h4>{min === max ? numberFormat({number: min, decimal: 2, style: 'currency'}) : `${numberFormat({number: min, decimal: 2, style: 'currency'})} - ${numberFormat({number: max, decimal: 2, style: 'currency'})}`}</h4>;
                  })() : <h4>{numberFormat({number:price?.amount,decimal:2, style:"currency"})}</h4>}
                </div>
              ))}

            {formik.values?.discount?.length > 0 &&
              formik.values?.discount?.map((dis) => (
                <div className="discount mb-4">
                  <p>
                    {(dis?.discount_type === 'Date' ||  dis?.discount_type === 'date') &&
                    dis?.start_date &&
                    dis?.end_date
                      ? `${dis?.discount_name} | ${formatDate({date:dis?.start_date, formatType:"defaultWithUTC"})}
                          -${formatDate({date:dis?.end_date, formatType:"defaultWithUTC"})}`
                      : dis?.discount_name}
                  </p>
                  <h4>{numberFormat({number:+dis?.value, decimal:2, style:"currency"})}</h4>
                </div>
              ))}
            <hr className="mb-5" />
            <div className="total">
              <p>TOTAL</p>
              <h4>{numberFormat({number:+total, decimal:2, style:"currency"})}</h4>
            </div>
          </div>
        </div>
      ) : (
        <div className="no_date">
          <ClassNoData />
          {/* <p className="no_date_p">No Results Yet</p> */}
        </div>
      )}
    </>
  );
};

export default InternalDrawer;
